import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useSearchableMultiSelectorComboboxStyles = makeStyles({
  root: {
    maxWidth: '400px',
    minWidth: 'auto',

    // '&::after': {
    //   content: 'none', // Removes the line
    //   borderBottom: 'none',
    // },
  },
  resultsTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  selectAllButton: {
    display: 'flex',
    color: '#115EA3',
    fontFamily: 'var(--FamilyBase)',
    fontSize: 'var(--Size300)',
    fontWeight: 400,
    lineHeight: 'var(--Lineheight300)',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
  },
});

export const useSearchableMultiSelectorTagsStyles = makeStyles({
  root: {
    marginBottom: '8px',
  },
  group: {
    flexWrap: 'wrap',
    ...shorthands.gap('8px'),
  },
});

export const useSearchableMultiSelectorStyles = makeStyles({
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: tokens.spacingVerticalXS,
    justifyContent: 'space-between',
  },
  labelContent: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: tokens.spacingVerticalXS,
  },
  removeAllButton: {
    display: 'flex',
    fontFamily: 'Segoe UI',
    fontSize: '12px',
    fontWeight: 400,
  },
});
